<div class="npdc-title">
  <h1 class="title">Map archive</h1>
  <div class="npdc-title__actions">
    @if (
      authService.user() &&
      (permissions()?.mayUpdate ||
        authService.canInvoke(authService.endpoints.createMapArchiveEntry))
    ) {
      <button class="npdc-toolbar-button" mat-flat-button (click)="onAddMapClick()">Add map</button>
    }
  </div>
</div>
<p>
  Search and explore maps from the Norwegian Polar Institute’s map archive. This is an extensive
  collection of historic and recent physical maps, mostly from the polar regions. To preserve their
  content and make them available to the wider public they have been digitised and stored as part of
  <a routerLink="/dataset/{{ mapDataset }}">this dataset</a>.
</p>

<p>To filter by map type or area use the button next to the search input.</p>

<div class="npdc-search">
  <div class="npdc-search__input">
    <div class="npdc-search__input__prefix">
      @if (mapList.isLoading()) {
        <mat-spinner matPrefix [diameter]="24"></mat-spinner>
      } @else {
        <mat-icon>search</mat-icon>
      }
    </div>
    <input
      type="search"
      placeholder="Search archive"
      [ngModel]="search()"
      (keydown.enter)="onSearch($event)"
    />
  </div>
  <button mat-icon-button (click)="advancedSearch()">
    <mat-icon>tune</mat-icon>
  </button>
</div>

@if (location() || parsedFilters().length) {
  <p>
    <mat-chip-set>
      @if (location()) {
        <mat-chip highlighted title="{{ location() }}">
          Location filter
          <mat-icon matChipRemove (click)="onGeoSearch()">cancel</mat-icon>
        </mat-chip>
      }
      @for (f of parsedFilters(); track f) {
        <mat-chip highlighted>
          {{ f.split(':')[1] }}
          <mat-icon matChipRemove (click)="onFilterClear()">cancel</mat-icon>
        </mat-chip>
      }
    </mat-chip-set>
  </p>
}

@if (mapExpanded()) {
  <p>
    <mat-card class="npdc-leaflet" appearance="outlined">
      <app-leaflet-group [geometry]="geojson()" [readonly]="true" [height]="'250px'" />
    </mat-card>
  </p>
}

<app-list [resource]="mapList">
  @if (!mapList.error()) {
    <p class="npdc-card-grid">
      @for (map of mapList.value()?.items; track map.id; let isLast = $last) {
        <a routerLink="/map/archive/{{ map.id }}" class="npdc-card-grid__link">
          <mat-card class="npdc-list-card" appearance="outlined">
            <app-card-image
              mat-card-image
              alt="{{ map.content.title }} thumbnail"
              src="{{ thumbBaseAddr }}&recordId={{ map.id }}"
            />

            <mat-card-header>
              <mat-card-title>{{
                map.content.title.length < 85
                  ? map.content.title
                  : (map.content.title | slice: 0 : 85) + '...'
              }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p>
                Publisher: {{ getPublisher(map) }}
                @if (getPublicationRange(map.content) !== '') {
                  <br />
                  Published: {{ getPublicationRange(map.content) }}
                }
              </p>
            </mat-card-content>
            <mat-card-footer>
              <mat-chip-set>
                @if (map.content.mapType) {
                  <mat-chip>{{ map.content.mapType }}</mat-chip>
                }
                @if (map.content.entryType) {
                  @if (map.content.entryType === publicationTypes['Single']) {
                    <mat-chip>{{ map.content.entryType }} map</mat-chip>
                  } @else {
                    <mat-chip>map {{ map.content.entryType }}</mat-chip>
                  }
                }
              </mat-chip-set>
            </mat-card-footer>
          </mat-card>
        </a>
      }
    </p>

    <mat-paginator
      showFirstLastButtons
      (page)="onPage($event)"
      [length]="count()"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="pageSizeOptions"
    ></mat-paginator>
  }
</app-list>
